/**
 * Create Address Page
 * 
 * Full-page wizard for creating liquidation addresses.
 * Accessible from /addresses/create route.
 * 
 * @module pages
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { semanticTokens } from '@packages/config/theme';
import { CreateAddressWizard } from '@/components/addresses/wizard';

export function CreateAddressPage() {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/dashboard/receive');
  };

  const handleSuccess = (address: string) => {
    console.log('[CreateAddressPage] Address created:', address);
  };

  return (
    <div className={cn(
      "min-h-screen flex flex-col",
      semanticTokens.bg.canvas
    )}>
      <CreateAddressWizard
        onClose={handleClose}
        onSuccess={handleSuccess}
      />
    </div>
  );
}

export default CreateAddressPage;

